module.exports = __webpack_public_path__ + "static/media/birds-9548.887b0b61.png";